export const useAvatarInitials = (name?: string): string => {
  if (!name) {
    return '';
  }
  const parts = name.trim().split(/\s+/);
  const initials = parts.map((part) => part[0]?.toUpperCase()).join('');
  return initials;
};
